import React from 'react';

const Webinars = () => {
  return (
    <div className="page">
      <h1>Webinars</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Webinars; 